export const downloadBlobAsFile = (
  data: BlobPart | BlobPart[],
  filename: string,
) => {
  const blobParts = Array.isArray(data) ? data : [data]
  const url = window.URL.createObjectURL(new Blob(blobParts))
  const link = document.createElement('a')

  link.href = url
  link.setAttribute('download', filename)

  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
